'use client';
import { getExposureRecord, sendClickTrack } from '../../tempo_track';
import { uaParse } from '@/intl-jdi-common-ssr/utils/uaParser';
import { useState } from 'react';
import styles from './style.module.scss';

interface AnchorProps {
  moduleData: any;
  pageCode: string;
  pos: number;
}
export default function Anchor({ moduleData, pageCode, pos }: AnchorProps) {
  const [anchorActive, setAnchorActive] = useState(0);
  const exposureRecord = getExposureRecord(pageCode);
  const anchorList = moduleData?.dataBatch?.anchorList;
  const style = moduleData?.dataStyle?.style;
  const isInJoybuyApp = uaParse().isInJoybuyApp;
  const handleClick = (item: any, index: number) => {
    sendClickTrack.cms_TempoPage_anchorbar_click(genEventTrackingInfo(item, index));
    setAnchorActive(index);
    const targetId = anchorList[index].floorId;
    const target = document.getElementById(`floor_${targetId}`);
    if (target) {
      scrollToWithOffset(target);
    }
  };

  const scrollToWithOffset = (element: any) => {
    const targetOffset = element.offsetTop;
    const floorHeight = document.getElementById(`floor_${moduleData?.floorId}`);
    // @ts-ignore
    const scrollDistance = floorHeight
      ? isInJoybuyApp
        ? targetOffset - floorHeight.clientHeight - 88
        : targetOffset - floorHeight.clientHeight
      : targetOffset; // 若未获取到floor元素，回退为目标元素顶部
    let container = document.getElementById('main-container');
    if (!container) {
      container = document.documentElement;
    }
    container.scrollTo({ top: scrollDistance, behavior: 'smooth' });
  };

  // ---------------- Style Setting ---------------- //
  const inactiveFontStyle = {
    color: style?.unselectedColor ? style?.unselectedColor : '#888b94',
  };
  const activeFontStyle = {
    color: style?.selectedColor ? style?.selectedColor : '#000',
    fontWeight: 700,
  };
  const activeRectStyle = {
    visibility: 'visible',
    backgroundColor: style?.selectedColor ? style?.selectedColor : '#000',
  };
  const containerStyle = {
    backgroundColor: style?.bgColor ? style?.bgColor : '#fff',
  };

  const genEventTrackingInfo = (item: any, index: number) => {
    const trackingParams = {
      moduleInstanceId: moduleData?.id,
      page_id: pageCode,
      pos: pos,
      index: index,
      text: item.title,
    };
    return trackingParams;
  };
  return (
    <div className={styles['uk-h5-anchor']}>
      <div id={'anchor'} className={`${styles.anchorContainer}`} style={containerStyle}>
        {anchorList.map((item: any, index: number) => (
          <div
            className={styles.item}
            style={anchorActive === index ? activeFontStyle : inactiveFontStyle}
            key={index}
            onClick={() => handleClick(item, index)}
            exptag={'exp|' + exposureRecord.cms_TempoPage_anchorbar_expo}
            data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.5}'
            data-exptag-json-param={JSON.stringify(genEventTrackingInfo(item, index))}
          >
            <p>{item.title}</p>
            <div
              className={styles.rect}
              // @ts-ignore
              style={anchorActive === index ? activeRectStyle : { visibility: 'hidden' }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
